// extracted by mini-css-extract-plugin
export default {"root":"mkC5t0"};